import React, { Component } from "react";

import styles from "./cmsUser.module.scss";
import { withUsers } from "../../../shared/containers/containerUsers";
import SideContentBlock from "../../../shared/sideContentBlock";
import SideContentInner from "../../../shared/sideContentInner";
import Preloader from "../../../shared/items/static/preloader";
import UserInformation from "./../../Controls/Users/UserInfornation"
import CmsUserRolePermissions from "./CmsUserRolePermissions";
import CmsUserPermissions from "./CmsUserPermissions";
import CmsUserOwnershipAreas from "./CmsUserOwnershipAreas";

const PATH = "/cms/users/";

class CmsUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      userId: null,
      error: null,
      tabIndex: 0,
    };
  }

  componentDidMount() {
    const userId = window.location.pathname.replace(PATH, "");
    this.setState({ userId });

    const { onGetUser } = this.props;
    onGetUser(userId);
  }

  setTabIndex(tabIndex) {
    this.setState({ tabIndex });
  }

  getTabs() {
    const { tabIndex } = this.state;
    const titles = ["Привилегии роли пользователя", "Пользовательские Привилегии вне роли", "Области владения"];

    return titles.map((item, index) => {
      return (
        <div key={index} className={tabIndex === index ? styles.cmsTabActive : styles.cmsTab} onClick={this.setTabIndex.bind(this, index)}>
          {item}
        </div>
      );
    });
  }

  getTabView() {
    const { tabIndex } = this.state;

    switch (tabIndex) {
      case 0:
        return <CmsUserRolePermissions />;
      case 1:
        return <CmsUserPermissions />;
      case 2:
        return <CmsUserOwnershipAreas />;
      default:
        return null;
    }
  }

  render() {
    const { currentUser, blockStatesDataState } = this.props;
    const { error } = this.state;

    if (currentUser === null) {
      return (
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Preloader />
        </div>
      );
    }

    return (
      <SideContentBlock>
        <SideContentInner>
          <div className={styles.cmsUserContainer}>
            <UserInformation />
            <div className={styles.tabsContainer}>{this.getTabs()}</div>
            <div>{this.getTabView()}</div>
          </div>
        </SideContentInner>
      </SideContentBlock>
    );
  }
}

export default withUsers(CmsUser);
